import React from 'react'
import { CommonTitle } from '../common'
import { useTranslation } from 'react-i18next'
import HTMLReactParser from 'html-react-parser'
import { CategoryDescription } from '../common/Wizard/styles'
import { Errors, FlexContainer, SelectInput } from 'heliocor-ui'
import { useDispatch, useSelector } from 'react-redux'
import { REQUEST_UPDATE_KYC_TYPE } from '../store/cafe/actionTypes'

export const KYCSelection = ({ errorHandler, settings }) => {

    const { t } = useTranslation()
    const dispatch = useDispatch()
    
    const [updating, setUpdating] = React.useState(false)

    const kycTypes = useSelector(store => store.settings.kycTypes)
    const kycType = useSelector(store => store.settings.kycType)
    
    const {KYCLabel, KYCStepName, KYCDescription} = settings
    const kycTypesOptions = kycTypes?.map(k => ({ label: k.nameCafe || k.name, value: k.identifier }))
    const errors = !kycType && [{id: t('errors.required')}]
    
    const updateKycType = (kycType) => {
        setUpdating(true)
        dispatch({
            type: REQUEST_UPDATE_KYC_TYPE,
            onSuccess: () => setUpdating(false),
            kycType
        })
    }

    React.useEffect(() => {
        return () => {
            errorHandler({kycType: []})
        }
    }, [])

    return (
        <>
            <CommonTitle value={KYCStepName || t('kycSelection')} />
            {KYCDescription && (
                <CategoryDescription>
                    {HTMLReactParser(KYCDescription)}
                </CategoryDescription>
            )}
            <FlexContainer padding='1rem 3rem' column>
                <SelectInput
                    id='kycType'
                    customLabel={KYCLabel || t("kycType")}
                    options={kycTypesOptions}
                    onChange={(k, option) => updateKycType(option?.value)}
                    value={kycType}
                    validations={['REQUIRED']}
                    errorHandler={errorHandler}
                    isClearable={false}
                    isLoading={updating}
                    disabled={updating}
                />
                <Errors errors={errors} margin='-24px 0 0'/>
            </FlexContainer>
        </>
    )
}